import { Box, Modal, ModalBackdrop, ModalContent, Text, VStack } from '@gluestack-ui/themed';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useQueryClient } from '@tanstack/react-query';
import { useContext, useState } from 'react';
import { Pressable } from 'react-native';

import { AuthContext } from '../contexts/session/Auth';
import { TranslationContext } from '../contexts/translations/Translation';
import { UserContext } from '../contexts/User';
import { COLORS } from '../theme/colors';
import { env } from '../utils/Env';
import { PrimaryButton } from './buttons/PrimaryButton';

// Term re-confirmation gate for academic students: once their enrolment window
// (studentUntil) has passed, block the app with a modal until they extend or log
// out. Company users have no studentUntil, so this never shows for them.
export const EnrollmentGate = () => {
  const userCtx = useContext(UserContext);
  const auth = useContext(AuthContext);
  const { i18n } = useContext(TranslationContext);
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);
  const b = 'page.enrollment';

  const studentUntil = (userCtx?.user as any)?.studentUntil;
  const expired = studentUntil ? new Date() >= new Date(studentUntil) : false;
  if (!expired) return null;

  const extend = async () => {
    setBusy(true);
    try {
      const token = await AsyncStorage.getItem('token');
      await fetch(`${env.apiBaseUrl}/me/confirm-enrollment`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      await queryClient.invalidateQueries({ queryKey: ['userMe'] });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal isOpen onClose={() => {}}>
      <ModalBackdrop />
      <ModalContent>
        <Box style={{ padding: 24 }}>
          <VStack gap={10}>
            <Text fontWeight="bold" fontSize={18}>{i18n?.t(`${b}.title`)}</Text>
            <Text fontSize={14} color={COLORS.NEUTRAL[90]}>{i18n?.t(`${b}.message`)}</Text>
            <PrimaryButton
              style={{ marginTop: 12, alignSelf: 'center' }}
              isLoading={busy}
              content={i18n?.t(`${b}.extend`)}
              onPress={extend}
            />
            <Pressable onPress={() => auth?.logOut?.()} style={{ alignSelf: 'center', marginTop: 6 }}>
              <Text fontSize={13} color={COLORS.ACCENT[100]}>{i18n?.t(`${b}.logout`)}</Text>
            </Pressable>
          </VStack>
        </Box>
      </ModalContent>
    </Modal>
  );
};
